import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-website',
  templateUrl: './layout-website.component.html',
  styleUrls: ['./layout-website.component.scss']
})
export class LayoutWebsiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
